/* This file is autogenerated, see readme.md for instructions */
import SendSvgIcon from '@bloomreach/banana-theme/icons/send.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SendIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SendSvgIcon />
    </Icon>
  );
});

SendIcon.displayName = 'SendIcon';

export default SendIcon;
